/* Logic for Course Product Page */
document.addEventListener('DOMContentLoaded', function () {
  initDateLogic();
  initReadMore();
  initAddToCart();
  sortBottomTable();
  initMobileStickyBar(); // Initialize the sticky bar logic
});
// Modal Logic
window.openLiteratureModal = function () {
  const modal = document.getElementById('literature-modal');
  if (modal) modal.style.display = 'flex';
}
window.closeLiteratureModal = function () {
  const modal = document.getElementById('literature-modal');
  if (modal) modal.style.display = 'none';
}
window.confirmLiteratureAdd = function () {
  const checkbox = document.getElementById('literature-checkbox');
  if (checkbox) {
    checkbox.checked = true;
    toggleLiterature(checkbox);
  }
  closeLiteratureModal();
}
window.toggleLiterature = function (checkbox) {
  const input = document.getElementById('literature_choice_input');
  if (checkbox.checked) {
    input.value = 'yes';
  } else {
    input.value = 'no';
  }
}
/* Handle Hero CTA Click for Mobile vs Desktop */
window.handleHeroCtaClick = function () {
  const isMobile = window.innerWidth < 750;
  if (isMobile) {
    // Scroll to bottom sticky bar or open select
    const stickySelect = document.getElementById('mobile-date-selector');
    if (stickySelect) {
      stickySelect.scrollIntoView({ behavior: 'smooth', block: 'end' });
      // optional: stickySelect.focus();
      // Or flash interaction
      setTimeout(() => stickySelect.style.borderColor = '#002B49', 500);
    }
  } else {
    // Scroll to Desktop Widget
    const widget = document.querySelector('.course-booking-widget-wrapper');
    if (widget) {
      widget.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
function initDateLogic() {
  const dateInputs = document.querySelectorAll('.js-course-date-input');
  dateInputs.forEach(input => {
    input.addEventListener('change', function () {
      document.querySelectorAll('.js-date-row').forEach(row => row.classList.remove('selected'));
      const row = input.closest('.js-date-row');
      if (row) row.classList.add('selected');
      // Update Global Prices
      const price = input.dataset.price;
      const comparePrice = input.dataset.comparePrice;
      updateGlobalPrices(price, comparePrice);
    });
  });
}
function updateGlobalPrices(price, comparePrice) {
  if (!price) return;
  // Selectors to update
  const els = [
    { price: '.course-hero__price', compare: '.course-hero__price--compare' },
    { price: '.booking-widget__price', compare: '.booking-widget__price--compare' }
  ];
  els.forEach(selector => {
    const priceEl = document.querySelector(selector.price);
    if (priceEl) {
      priceEl.innerText = price;
      // Handle Sale styling (Explicit Color)
      if (comparePrice) {
        priceEl.classList.add('course-hero__price--sale'); 
        priceEl.style.color = '#B91C1C';
      } else {
        priceEl.classList.remove('course-hero__price--sale');
        priceEl.style.color = '#000000';
      }
    }
    const compareEl = document.querySelector(selector.compare);
    if (compareEl) {
      if (comparePrice) {
        compareEl.style.display = 'inline';
        compareEl.innerText = comparePrice;
      } else {
        compareEl.style.display = 'none';
      }
    }
  });
}
function initReadMore() {
  const btn = document.querySelector('.js-read-more-btn');
  const desc = document.querySelector('.course-content__description');
  if (btn && desc) {
    if (desc.scrollHeight > 300) {
      btn.style.display = 'inline-block';
    } else {
      btn.style.display = 'none';
    }
    btn.addEventListener('click', function () {
      if (desc.classList.contains('truncated')) {
        desc.classList.remove('truncated');
        desc.classList.add('expanded');
        btn.innerText = 'Visa mindre';
      } else {
        desc.classList.remove('expanded');
        desc.classList.add('truncated');
        desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
        btn.innerText = 'Läs mer';
      }
    });
  }
}
function sortBottomTable() {
  const table = document.querySelector('.course-list-bottom .course-table tbody');
  if (!table) return;
  const rows = Array.from(table.querySelectorAll('.js-course-list-row'));
  rows.forEach(row => {
    const isoDate = row.dataset.isoDate;
    if (isoDate && isoDate !== 'legacy' && isoDate.length >= 10) {
      row.dataset.timestamp = new Date(isoDate).getTime();
      return;
    }
    const dateStr = row.dataset.legacyDate;
    if (dateStr) {
      const match = dateStr.match(/(\d+)\s+([a-zA-Zäåö]+)/);
      if (match) {
        const cleanDate = match[1] + " " + match[2];
        const dateObj = parseRoughDate(cleanDate);
        if (dateObj) {
          row.dataset.timestamp = dateObj.getTime();
        } else {
          row.dataset.timestamp = "9999999999999";
        }
      } else {
        row.dataset.timestamp = "9999999999999";
      }
    }
  });
  rows.sort((a, b) => {
    return parseInt(a.dataset.timestamp) - parseInt(b.dataset.timestamp);
  });
  rows.forEach(row => table.appendChild(row));
}
function parseRoughDate(dateStr) {
  const months = {
    'jan': 0, 'feb': 1, 'mar': 2, 'apr': 3, 'maj': 4, 'jun': 5,
    'jul': 6, 'aug': 7, 'sep': 8, 'okt': 9, 'nov': 10, 'dec': 11,
    'januari': 0, 'februari': 1, 'mars': 2, 'april': 3, 'maj': 4, 'juni': 5,
    'juli': 6, 'augusti': 7, 'september': 8, 'oktober': 9, 'november': 10, 'december': 11
  };
  try {
    const parts = dateStr.trim().split(/\s+/);
    if (parts.length < 2) return null;
    const day = parseInt(parts[0]);
    let monthStr = parts[1].toLowerCase().substring(0, 3);
    const month = months[monthStr];
    if (month === undefined) return null;
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    let year = currentYear;
    if (month < currentMonth - 1) {
      year++;
    }
    return new Date(year, month, day);
  } catch (e) {
    return null;
  }
}
function initAddToCart() {
  const forms = document.querySelectorAll('.js-course-booking-form');
  forms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.innerText;
      submitBtn.disabled = true;
      submitBtn.innerText = 'Bokar...';
      const formData = new FormData(form);
      const items = [{ id: formData.get('id'), quantity: 1 }];
      if (formData.get('literature_choice') === 'yes') {
        const litId = formData.get('literature_id');
        if (litId) {
          items.push({ id: litId, quantity: 1 });
        }
      }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(r => r.json())
        .then(() => { window.location.href = '/checkout'; })
        .catch(err => {
          console.error(err);
          submitBtn.disabled = false;
          submitBtn.innerText = originalText;
          alert('Fel vid bokning. Försök igen.');
        });
    });
  });
}
function initMobileStickyBar() {
  const mobileSelect = document.getElementById('mobile-date-selector');
  const subtitle = document.getElementById('mobile-sticky-subtitle');
  const priceDisplay = document.getElementById('mobile-display-price');
  if (mobileSelect) {
    mobileSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      if (!selectedOption.value) return;
      // Get Data with fallback
      let loc = selectedOption.dataset.location || '';
      const stock = parseInt(selectedOption.dataset.stock || '0');
      const newPrice = selectedOption.dataset.price;
      const comparePrice = selectedOption.dataset.comparePrice || null;
      const title = selectedOption.dataset.title || '';
      // Fallback location parsing if empty
      if (!loc && title) {
        const parts = title.split(' - ');
        if (parts.length > 1) loc = parts[1];
        else {
          const partsDos = title.split(' – '); // En-dash
          if (partsDos.length > 1) loc = partsDos[1];
        }
      }
      // Update Price
      if (newPrice && priceDisplay) {
        priceDisplay.innerText = newPrice;
      }
      // Update Global Prices (Hero/Widget) from Mobile selection
      updateGlobalPrices(newPrice, comparePrice);
      // Format Stock Text
      let stockText = '';
      let stockColor = '#666';
      if (stock <= 0) {
        stockText = 'Fullbokad';
      } else if (stock < 4) {
        stockText = stock + ' platser kvar';
        stockColor = '#B91C1C'; // Red
      } else if (stock < 8) {
        stockText = stock + ' platser kvar';
        stockColor = '#B45309'; // Yellow/Orange
      } else {
        stockText = '8+ platser kvar';
        stockColor = '#047857'; // Green
      }
      // Update Subtitle
      if (loc) {
        subtitle.innerHTML = '<span>' + loc + '</span> <span style="color:#ccc">|</span> <span style="color:' + stockColor + '; font-weight:700;">' + stockText + '</span>';
      } else {
        subtitle.innerHTML = '<span style="color:' + stockColor + '; font-weight:700;">' + stockText + '</span>';
      }
    });
    // Manually trigger if value is already selected (browser autofill)
    if (mobileSelect.value) {
      mobileSelect.dispatchEvent(new Event('change'));
    }
  }
}
// Share Functionality
function shareCourse() {
  const title = document.title.split('–')[0].split('-')[0].trim(); // Try to get clean title
  const url = window.location.href;
  const text = 'Kolla in den här kursen hos Sjölotsen:';
  const shareData = {
    title: title,
    text: text,
    url: url
  };
  if (navigator.share) {
    navigator.share(shareData)
      .catch((err) => console.log('Error sharing:', err));
  } else {
    // Desktop / Fallback -> Mailto
    // The user specifically requested a good subject and body on desktop.
    const subject = `Tips om kurs: ${title}`;
    const body = `${text}\n\n${title}\n${url}\n\n`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }
}